module.exports = [{
      plugin: require('/tmp/2cb18442/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/2cb18442/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/2cb18442/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
